import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { IFilterList } from 'wisestep-base';

import TasksAdvanceFilterFormProps from '../../../components/filters/models/TasksAdvanceFiltersFormProps';

export const pushTaskFilters = (data: TasksAdvanceFilterFormProps) => {
  const filtersArray: IFilterList[] = [];
  const formattedDate = (date: string): string => dayjs(date).format('DD/MM/YYYY');
  if (!isEmpty(data.company))
    filtersArray.push({
      tag: `Company: ${data.company?.join(',')}`,
      id: 'company',
    });
  if (!isEmpty(data.jobCodes))
    filtersArray.push({
      tag: `Job Codes: ${data.jobCodes?.join(',')}`,
      id: 'jobCodes',
    });
  if (!isEmpty(data.jobTitles))
    filtersArray.push({
      tag: `Job Titles: ${data.jobTitles?.join(',')}`,
      id: 'jobTitles',
    });
  if (!isEmpty(data.locations))
    filtersArray.push({
      tag: `Location(s): ${data.locations
        ?.map((location) => `${location.country}-${location.state}-${location.city}`)
        .join(',')}`,
      id: 'locations',
    });
  if (!isEmpty(data.recruiters))
    filtersArray.push({
      tag: `Recruiter(s): ${data.recruiters?.join(',')}`,
      id: 'recruiters',
    });
  if (!isEmpty(data.teams))
    filtersArray.push({
      tag: `Team(s): ${data.teams?.join(',')}`,
      id: 'teams',
    });
  if (data.createBWDates?.toDateName)
    filtersArray.push({
      tag: `Created b/w: ${
        data?.createBWDates.fromDateName
          ? formattedDate(data.createBWDates?.fromDateName.toString())
          : ''
      } to ${
        data?.createBWDates.toDateName
          ? formattedDate(data.createBWDates?.toDateName.toString())
          : ''
      }`,
      id: 'createBWDates',
    });
  if (data.updatedBWDates?.toDateName)
    filtersArray.push({
      tag: `Updated b/w: ${
        data?.updatedBWDates.fromDateName
          ? formattedDate(data.updatedBWDates?.fromDateName.toString())
          : ''
      } to ${
        data?.updatedBWDates.toDateName
          ? formattedDate(data.updatedBWDates?.toDateName.toString())
          : ''
      }`,
      id: 'updatedBWDates',
    });

  return filtersArray;
};
